import React, { FC } from 'react';

const IconTarjeta: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Icon / tarjeta</title>
      <g stroke="none" strokeWidth="1" fillRule="evenodd">
        <path d="M24,17 C24,19.209139 22.209139,21 20,21 L4,21 C1.790861,21 2.705415e-16,19.209139 0,17 L24,17 Z M20,3 C22.209139,3 24,4.790861 24,7 L24,14 L0,14 L0,7 C-2.705415e-16,4.790861 1.790861,3 4,3 L20,3 Z M18,6 C16.8954305,6 16,6.8954305 16,8 C16,9.1045695 16.8954305,10 18,10 C19.1045695,10 20,9.1045695 20,8 C20,6.8954305 19.1045695,6 18,6 Z" />
      </g>
    </svg>
  );
};

export default IconTarjeta;
